<template>
  <div>
    <portal to="tabs">
      <v-tabs v-model="tabSelected" background-color="transparent">
        <v-tab>Шаблоны</v-tab>
        <v-tab>Поля</v-tab>
        <v-tab>Верхний/Нижний колонтитул</v-tab>
        <v-tab>Блоки</v-tab>
      </v-tabs>
    </portal>
    <SettingsMrDocumentTemplates v-if="tabSelected===0"/>
    <SettingsMrDocumentTemplateFields v-if="tabSelected===1"/>
    <SettingsMrDocumentHeaderFooter v-if="tabSelected===2"/>
    <SettingsMrDocumentBlocks v-if="tabSelected===3"/>
  </div>
</template>

<script>
import SettingsMrDocumentTemplates from "@/views/Settings/documents/SettingsMrDocumentTemplates";
import SettingsMrDocumentTemplateFields from "@/views/Settings/documents/SettingsMrDocumentTemplateFields";
import SettingsMrDocumentHeaderFooter from "@/views/Settings/documents/SettingsMrDocumentHeaderFooter";
import SettingsMrDocumentBlocks from "@/views/Settings/documents/SettingsMrDocumentBlocks";
export default {
  components: {
    SettingsMrDocumentTemplates,
    SettingsMrDocumentTemplateFields,
    SettingsMrDocumentHeaderFooter,
    SettingsMrDocumentBlocks
  },
  data:()=>({
    tabSelected:null,
  }),
}
</script>
